import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  Paper,
  Link,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import RGPDService from '../services/rgpdService';

const RGPDBanner = () => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (RGPDService.shouldShowBanner()) setOpen(true);

    const handleReopen = () => setOpen(true);
    window.addEventListener('rgpd:show-banner', handleReopen);
    return () => window.removeEventListener('rgpd:show-banner', handleReopen);
  }, []);

  const handleAcceptAll = () => {
    const allConsents = {
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true,
    };
    RGPDService.saveConsent(allConsents);
    RGPDService.markBannerShown();
    setOpen(false);
  };

  const handleRejectAll = () => {
    const minimalConsents = {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false,
    };
    RGPDService.saveConsent(minimalConsents);
    RGPDService.markBannerShown();
    setOpen(false);
  };

  if (!open) return null;

  return (
    <Paper
      elevation={6}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        borderRadius: isMobile ? '16px 16px 0 0' : '16px',
        margin: isMobile ? 0 : 2,
        maxWidth: isMobile ? '100%' : '400px',
        marginLeft: isMobile ? 0 : 'auto',
        marginRight: isMobile ? 0 : 2,
        backgroundColor: theme.palette.background.paper,
        border: `2px solid ${theme.palette.primary.main}`,
      }}
    >
      <Box sx={{ p: isMobile ? 2 : 3 }}>
        <Typography
          variant={isMobile ? "subtitle1" : "h6"}
          sx={{
            fontWeight: 600,
            mb: 1.5,
            color: theme.palette.text.primary
          }}
        >
          Acceptez-vous les cookies ?
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 2,
            color: theme.palette.text.secondary,
            lineHeight: 1.4
          }}
        >
          Nous utilisons des cookies pour améliorer votre expérience et analyser notre trafic.
        </Typography>

        <Box sx={{
          display: 'flex',
          gap: 1,
          flexDirection: isMobile ? 'column' : 'row',
          mb: 1.5
        }}>
          <Button
            variant="contained"
            onClick={handleAcceptAll}
            size={isMobile ? "medium" : "small"}
            sx={{
              flex: 1,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Accepter tout
          </Button>
          <Button
            variant="outlined"
            onClick={handleRejectAll}
            size={isMobile ? "medium" : "small"}
            sx={{
              flex: 1,
              borderRadius: 2,
              textTransform: 'none'
            }}
          >
            Refuser
          </Button>
        </Box>

        <Typography variant="caption" sx={{ color: theme.palette.text.secondary }}>
          <Link
            href="/politique-confidentialite"
            sx={{
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Politique de confidentialité
          </Link>
          {' • '}
          <Link
            href="/mentions-legales"
            sx={{
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            Mentions légales
          </Link>
        </Typography>
      </Box>
    </Paper>
  );
};

export default RGPDBanner;
